import React, { PureComponent } from "react";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { Link } from "react-router";
import enhanceWithClickOutside from "react-click-outside";
import PermittedHeader from "../../services/PermittedHeader";
import CompanyMenu from "./CompanyMenu";
import PropTypes from "prop-types";
import HocPermission from "./HocPermission";
import EkoModal from "../elements/EkoModal";
import Api from "../../util/Api.js"
import axios from "axios";
import { ROOT_URL } from "../../actions";
import { toastr } from "react-redux-toastr";
import { EkoFormButton } from "../elements/EkoForm.js";

class TopNavigationMenu extends PureComponent {
  constructor(props) {
    super(props);
    const today = new Date().toISOString().split('T')[0];
    this.state = {
      openMenu: false,
      openMyCompaniesModal: false,
      iFrameHeight: '800',
      reloadMainWindow: false,
      usdRate: "...",
      eurRate: "...",
      gbpRate: "...",
      chfRate: "...",
      rubRate: "...",
      showCloseIcon: false, // Başlangıçta gizli
      isCurrencyVisible: false, // Varsayılan olarak açık kalsın
      isCurrencyDropdownOpen: false,
      currentRateDate: null,
      currentRateDate: today
    };
  }

  handleCurrencyToggle = (isOpen, event, { source }) => {
    if (source === 'select') {
      return;
    }
    this.setState({ isCurrencyDropdownOpen: isOpen });
  };

  onChangeVisibleCurrency() {
    let newCompanySettings = this.state.newCompanySettings || {};
    toastr.confirm(`Döviz kuru ekranını gizlemek istediğinize emin misiniz? Dilediğiniz zaman Ayarlar sayfasından tekrar açabilirsiniz.`, {
      onOk: () => {
        newCompanySettings["currency_rate_visible"] = 0;
        Api.post(
          "/updateCompanySettings", newCompanySettings,
          (response, postErrors) => {
            this.setState({ isCurrencyVisible: false })
          });
      },
      onCancel: () => { },
      okText: "Evet",
      cancelText: "Hayır"
    });

  }

  componentDidMount() {
    this.fetchRates(this.state.currentRateDate);
    this.getCurrentCompanySettings()
  }
  async getCurrentCompanySettings() {
    try {
      this.setState({ loading: true });
      const response = await axios.get(ROOT_URL + "/getCompanySettings", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      var currentCompanySettings = response.data.result || {};
      console.log("ababab", currentCompanySettings.currency_rate_visible);

      if (currentCompanySettings?.currency_rate_visible === null || currentCompanySettings.currency_rate_visible == "0") {
        this.setState({ isCurrencyVisible: false })
      } else {
        this.setState({ isCurrencyVisible: true })
      }


    } catch (error) {
    }
  }
  fetchRates = (selectedDate = null) => {
    Api.getCurrencyRateAll("ALL", selectedDate, (data, error) => {
      if (!error && data) {
        this.setState({
          allRates: data,
          usdRate: data.USD ? parseFloat(data.USD.buying_forex).toFixed(2) : "...",
          currentRateDate: selectedDate
        });
      } else {
        console.error("Kurlar alınırken hata oluştu:", error);
      }
    });
  };

  isPermitted(pageId, html) {
    return PermittedHeader.isPermitted(pageId, html);
  }

  handleClickOutside() {
    this.setState({ openMenu: false });
  }

  openClose() {
    this.setState({ openMenu: !this.state.openMenu });
  }

  close() {
    this.setState({ openMenu: false });
  }

  render() {
    let menuClassName = "dropdown dropdown-user dropdown-dark ";
    const user = JSON.parse(localStorage.getItem("user"));
    var is_admin_user = 0;
    if (user.id === 2) {
      is_admin_user = 1;
    }

    let email = "";
    if (user) {
      if (user.firstname === null && user.lastname === null) {
        email = user.email;
      } else {
        email = `${user.firstname} ${user.lastname}`;
      }
    }

    if (this.state.openMenu) {
      menuClassName += "open";
    }
    var apiUrl = process.env.REACT_APP_API_URL;
    apiUrl = apiUrl.substring(0, apiUrl.length - 3);
    var time = new Date();

    if (this.state.reloadMainWindow === true) {
      window.location.reload();
    }
    return (
      <>

        <EkoModal
          showModal={this.state.openMyCompaniesModal}
          title="Şirketlerim"
          bsSize="xlg"
          onCancel={() => {
            this.setState({
              openMyCompaniesModal: false,
              reloadMainWindow: !this.state.reloadMainWindow
            });
          }}
          onHide={() => {
            this.setState({
              openMyCompaniesModal: false,
              reloadMainWindow: !this.state.reloadMainWindow
            });
          }}
          spinner={true}
        >
          <iframe
            style={{ overflow: 'visible' }}
            ref="iframe"
            src={apiUrl + "panel/my-companies.php?&t=" + localStorage.getItem('token')}
            scrolling="auto"
            frameBorder="0"
            width="100%"
            height={this.state.iFrameHeight}
          />
        </EkoModal>

        <div className="top-menu">

          {/* ------Kur gelecek kısım------ */}
          {this.state.isCurrencyVisible ? <div style={{ display: "inline-block", position: "relative" }}
            onMouseEnter={() => this.setState({ showCloseIcon: true })}
            onMouseLeave={() => this.setState({ showCloseIcon: false })}
          >
            {this.state.showCloseIcon && (
              <div
                onClick={() => {
                  this.onChangeVisibleCurrency();
                }}
                style={{
                  position: "absolute",
                  top: "5px",      // DropdownButton marginTop değerine göre ayarlanabilir
                  right: "5px",    // Sağdan boşluk
                  zIndex: 999,
                  cursor: "pointer",
                  backgroundColor: "#e7505a",
                  color: "white",
                  borderRadius: "50%",
                  width: "16px",
                  height: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "10px",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
                }}
              >
                <i className="fa fa-times"></i>
              </div>
            )}
            <DropdownButton
              style={{ marginTop: 10, marginRight: 10 }}
              title={`USD: ${this.state.usdRate}₺`}
              id="bg-nested-dropdown"
              open={this.state.isCurrencyDropdownOpen} // Manuel kontrol
              onToggle={this.handleCurrencyToggle}     // Manuel kontrol fonksiyonu
            >
              <div style={{ padding: '8px 15px', minWidth: '280px' }}>

                {/* --- TARİH SEÇİCİ BÖLÜMÜ --- */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column', // Etiket üstte, input/buton altta olsun
                    gap: '5px',
                    marginBottom: '10px',
                    borderBottom: '1px solid #eee',
                    paddingBottom: '15px'
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Etiket Kısmı */}
                  <label style={{ fontSize: '11px', color: '#888', marginBottom: '0' }}>
                    Kur Tarihi:
                  </label>

                  {/* Input ve Butonun Yan Yana Olduğu Satır */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="date"
                      className="form-control input-sm"
                      style={{
                        flex: '1',      // Inputun kalan alanı kaplamasını sağlar
                        height: '30px', // Buton yüksekliği ile eşitlemek için (gerekirse ayarla)
                        fontSize: '12px'
                      }}
                      value={this.state.currentRateDate}
                      onChange={(e) => this.setState({ currentRateDate: e.target.value })}
                      //onFocus={(e) => e.stopPropagation()}
                      max={new Date().toISOString().split('T')[0]}
                    />

                    {/* Butonun etrafındaki olası boşlukları sıfırlamak için bir div içine alabilirsin */}
                    <div style={{ marginTop: '-5px' }}>
                      <EkoFormButton
                        label="Getir" // "Ayarları Kaydet" yerine daha kısa bir isim dropdown'ı genişletmez
                        faClass="fa fa-refresh"
                        onClick={() => {
                          this.fetchRates(this.state.currentRateDate);
                        }}
                      />
                    </div>
                  </div>
                </div>

                <table className="table table-hover" style={{ marginBottom: 0 }}>
                  <thead>
                    <tr style={{ fontSize: '11px', color: '#888' }}>
                      <th>Döviz</th>
                      <th className="text-right">Alış</th>
                      <th className="text-right">Satış</th>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: '12px', fontWeight: 'bold' }}>
                    {this.state.allRates ? Object.keys(this.state.allRates).map((symbol) => {
                      const item = this.state.allRates[symbol];
                      return (
                        <tr key={symbol}>
                          <td>{symbol}</td>
                          <td className="text-right" style={{ color: '#26C281' }}>
                            {parseFloat(item.buying_forex).toFixed(4)}
                          </td>
                          <td className="text-right" style={{ color: '#E7505A' }}>
                            {parseFloat(item.selling_forex).toFixed(4)}
                          </td>
                        </tr>
                      );
                    }) : (
                      <tr><td colSpan="3" className="text-center">Yükleniyor...</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </DropdownButton>
          </div> : ""}
          {/* ------Kur gelecek kısım------ */}

          <CompanyMenu path={this.props.path} />


          {email ? (
            this.props.subscriberExpiredMenu ? (
              <ul className="nav navbar-nav pull-right">
                <li className={menuClassName}>
                  <a
                    onClick={this.openClose.bind(this)}
                    className="dropdown-toggle"
                    data-toggle="dropdown"
                    data-hover="dropdown"
                    data-close-others="true"
                    aria-expanded="true"
                  >
                    <span className="username username-hide-mobile">
                      {email}
                      <i className="fa fa-caret-down" aria-hidden="true" />
                    </span>
                  </a>
                  <ul className="dropdown-menu dropdown-menu-default">
                    {parseInt(user.plan_id, 10) !== 0 ? (
                      <li>
                        <Link to="/dashboard">
                          <i className="fa fa-step-backward" />
                          Uygulamaya Dön
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    {user.role_id==1 ? (
                      <li>
                        <Link to="/subscriber">
                          <i className="icon-envelope" />
                          Abone Ol
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    <li>
                      <a href="#" onClick={this.props.logout}>
                        <i className="icon-logout" />
                        Çıkış Yap
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            ) : (
              <ul className="nav navbar-nav pull-right">
                <li className={menuClassName}>
                  <a
                    onClick={this.openClose.bind(this)}
                    className="dropdown-toggle"
                    data-toggle="dropdown"
                    data-hover="dropdown"
                    data-close-others="true"
                    aria-expanded="true"
                  >
                    <span className="username username-hide-mobile">
                      {email}
                      <i className="fa fa-caret-down" aria-hidden="true"></i>
                    </span>
                  </a>
                  <ul className="dropdown-menu dropdown-menu-default">
                    {is_admin_user == 1 ? (
                      <HocPermission pkey="COMPANY_INFO">
                        <li>
                          <Link
                            activeClassName={"menu-active"}
                            to="/dashboard/user-list"
                            onClick={this.close.bind(this)}
                          >
                            <i className="icon-list" />
                            Kullanıcı Yönetimi
                          </Link>
                        </li>
                      </HocPermission>
                    ) : (
                      ""
                    )}
                    <HocPermission pkey="COMPANY_INFO">
                      <li>
                        <Link
                          activeClassName={"menu-active"}
                          to="/dashboard/companySettings"
                          onClick={this.close.bind(this)}
                        >
                          <i className="icon-briefcase" />
                          Şirket Bilgileri
                        </Link>
                      </li>
                    </HocPermission>

                    {/* {this.isPermitted("4", <li>
                                            <Link activeClassName={'menu-active'} to="/dashboard/companyOtherInfo" onClick={this.close.bind(this)}><i
                                                className="icon-user"/> Şirket Bilgileri</Link>
                                        </li>)} */}

                    <HocPermission pkey="USER_LIST">
                      <li>
                        <Link
                          activeClassName={"menu-active"}
                          to="/dashboard/companyUserRole"
                          onClick={this.close.bind(this)}
                        >
                          <i className="icon-calendar" />
                          Kullanıcı Ekle
                        </Link>
                      </li>
                    </HocPermission>

                    {user.role_id==1 ? (<li>
                      <Link
                        activeClassName={"menu-active"}
                        to="/dashboard/integrations"
                        onClick={this.close.bind(this)}
                      >
                        <i className="far fa-file-alt" />
                        Entegrasyonlar
                      </Link>
                    </li>) : (
                      ""
                    )}

                    {user.role_id==1 ? (
                      <li>
                        <Link activeClassName={"menu-active"} to="/subscriber">
                          <i className="icon-envelope" />
                          Abone Ol
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    <li className="divider" />
                    <li>
                      <Link
                        activeClassName={"menu-active"}
                        to="/dashboard/templates"
                        onClick={this.close.bind(this)}
                      >
                        <i className="far fa-file-alt" />
                        Yazdırma Şablonları
                      </Link>
                    </li>
                    <li>
                      <Link
                        activeClassName={"menu-active"}
                        to="/dashboard/barcodeTemplates"
                        onClick={this.close.bind(this)}
                      >
                        <i className="far fa-file-alt" />
                        Barkod Şablonları
                      </Link>
                    </li>
                    {user.company_type == "9" ? (
                      <li>
                        <Link onClick={() => {
                          this.setState({
                            openMyCompaniesModal: true
                          });
                        }}
                        >
                          <i className="fa fa-building" />
                          Şirketlerim
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    <li>
                      <Link
                        activeClassName={"menu-active"}
                        to="/dashboard/accountingSettings"
                        onClick={this.close.bind(this)}
                      >
                        <i className="icon-settings" />
                        Muhasebe Ayarları
                      </Link>
                    </li>
                    <li>
                      <Link
                        activeClassName={"menu-active"}
                        to="/dashboard/softwareSettings"
                        onClick={this.close.bind(this)}
                      >
                        <i className="fa fa-cog" />
                        Yazılım Ayarları
                      </Link>
                    </li>
                    <li>
                      <Link
                        activeClassName={"menu-active"}
                        to="/dashboard/userInfo"
                        onClick={this.close.bind(this)}
                      >
                        <i className="icon-key" />
                        Profilim
                      </Link>
                    </li>
                    <li>
                      <a href="#" onClick={this.props.logout}>
                        <i className="icon-logout" />
                        Çıkış Yap
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            )
          ) : (
            ""
          )}
        </div>
      </>

    );
  }
}

TopNavigationMenu.propTypes = {
  path: PropTypes.string.isRequired
};

export default enhanceWithClickOutside(TopNavigationMenu);